<template>
   <v-img class="white--text" height="150px" src="/static/img/blog-1.jpg">
      <div class="media align-items-center pa-3 w-100">
         <div class="media-left mr-2">
            <v-icon>fas fa-cogs</v-icon>
         </div>
         <div class="media-body" v-if="getUser">
            <h5 class="mb-0">Administrativo</h5>
            <h6 class="mb-0">{{getUser.empresa.razon_social}}</h6>
            <span class="fs-12 fw-normal text-truncate"><v-icon size="small">fas fa-envelope</v-icon> {{getUser.empresa.email}}</span>
            <br/>
            <span class="fs-12 fw-normal text-truncate"><v-icon size="small">fas fa-mobile-alt</v-icon> {{getUser.empresa.celular}}</span>
         </div>
      </div>
   </v-img>
</template>

<script>
   import { mapGetters } from 'vuex'
   export default {
      data: () => ({
      }),
      computed: {
         ...mapGetters([
            'getUser'
         ])
      },
      watch: {
      },
      created () {
      },
      methods: {
      }
   }
</script>